
const envCopy: any = {};
(<any>Object).assign(envCopy, (<any>window).env);
const GLOBAL_AUTH_TOKEN = envCopy.globalAuthorizationToken;
const AUTH_URI = envCopy.auth;
const SERVICE_URI = envCopy.services;
const SERVICE_CLOUD = envCopy.cloud;
const PAYMENT_COMPONENT_URI = envCopy.paymentsComponent;

export const GiftCardsAppConstants = {
    lang: 'es',
    market: 'ES',
    timeWait: 2000,
    numAttemps: 3,
    servicesURI: SERVICE_URI,
    env: envCopy,
    LABELS_ROUTE: '/iberia-web-content/literales/baggage-calculator/',
    LOGIN_ONB: 'ONB',
    defaultBackgroundImageWidth: 'generico/disponibilidad_default_',
    defaultBackgroundImage: 'generico/disponibilidad_default_2000.jpg',
    backgroundImagesBaseRoute: '/background/',
    //app Routes
    i18nRoute: '/iberia-web-content/literales/gift-cards/',
    generalI18nRoute: '/iberia-web-content/literales/general/',
    iconsRoute: '/iberia-web-content/iconos',
    localeRoute: '/iberia-web-content/locales',
    imagesRoute: '/iberia-web-content/imagenes',
    linksRoute: '/iberia-web-content/links/baggage-calculator',
    templatesRoute: 'web-gift-cards/templates/',
    componentModalRoute: 'web-gift-cards/templates/',
    availableLanguages: ['en', 'es', 'ls', 'zh', 'ca', 'de', 'fr', 'it', 'pt', 'ja', 'nl', 'ru'],
    defaultLang: 'es',
    defaultMarket: 'ES',
    PROCESS: 'tarjeta regalo',
    CONTRIBUTION_ERROR_MODAL_DATA: {
        APP_VCH_ERR_0005: {
            TITLE: 'GIFT_CARDS_TITLE_TERM_EXPIRED',
            BODY: 'GIFT_CARDS_BODY_TERM_EXPIRED'
        },
        APP_VCH_ERR_0007: {
            TITLE: 'GIFT_CARDS_TITLE_GENERIC_ERROR',
            BODY: 'GIFT_CARDS_BODY_GENERIC_ERROR'
        },
        APP_VCH_ERR_0008: {
            TITLE: 'GIFT_CARDS_BODY_TERM_MAXIMUM_AMOUNT_EXCEEDED',
            BODY: 'GIFT_CARDS_BODY_TERM_EXPIRED'
        },
        APP_VCH_ERR_0009: {
            TITLE: 'GIFT_CARDS_TITLE_GENERIC_ERROR',
            BODY: 'GIFT_CARDS_BODY_GENERIC_ERROR'
        }
    },
    QUADRIGAMS: {
        REGALO: 'REGALO',
        REGOTR: 'REGOTR',
        REGMIO: 'REGMIO',
        GIFTCARDS_PAYMENT: 'REPURC',
        REBKCF: 'REBKCF'
    },
    QUADRIGAM_STEPS: {
        INICIO: 'inicio',
        SELECCION: 'seleccion',
        PAGO: 'pago',
        CONFIRMACION: 'confirmacion'
    },
    TYPE: {
        GIFTCARD: 'GIFTCARD'
    },
    SUBTYPES: {
        GROUP: 'GROUP',
        INDIVIDUAL: 'INDIVIDUAL',
        OWN: 'OWN'
    },
    TIMES: {
        SCHEDULED: 'SCHEDULED',
        NOW: 'NOW'
    },
    DATALAYER_EVENT_TYPES: {
        VIEW: 'view'
    },
    COOKIES: {
        PERSONALIZATION: 'IBERIACOM_PERSONALIZATION',
        LOGGED_TOKEN: 'IBERIACOM_SSO_ACCESS',
        LOGGED_TOKEN_EXPIRATION: 'IBERIACOM_SSO_ACCESS_TO',
        LOGGED_REFRESH_TOKEN: 'IBERIACOM_SSO_REFRESH',
        LOGGED_REFRESH_TOKEN_EXPIRATION: 'IBERIACOM_SSO_REFRESH_TO',
        DEFAULT_EXPIRY_TIME: 1000 * 60 * 60 * 24 * 365 * 10, //ten years
        DEFAULT_PATH: '/'
    },
    nameParameters: {
        lang: 'language',
        market: 'market',
        paymentStatus: 'paymentStatus',
        componentType: 'componentType'
    },
    STEPS: {
        PAGOS: 'ibpurc',
        HOME: 'home',
        CONFIRMATION: 'confirmation',
        STEPS: 'GIFTCARDS_STEPS',
        CONTRIBUTION_STEPS: 'GIFTCARDS_CONTRIBUTION_STEPS'
    },
    WCS: {
        PHONE_TYPES: {
            SALES: 'RESERVAS',
            IBHOLIDAYS: 'ATTBAH'
        }
    },
    DEFAULT_ENDPOINTS: {
        AVAILABILITY: `${SERVICE_CLOUD}/v1/voucher/availability`,
        AVAILABILITY_CONTRIBUTION:  `${SERVICE_CLOUD}/v1/voucher/availability?flowId={{flowId}}`,
        GIFCARD: `${SERVICE_CLOUD}/v1/voucher/{flowId}/management`,
        customerDataURI: `${SERVICE_URI}/cust-cust/rs/v1/customer/complete`,
        CONDITIONS: `${SERVICE_URI}/orm-ors/rs/v1/giftcard/campaigns/conditions`,
        AVAILABILITYPERMISSION: `${SERVICE_CLOUD}/v1/voucher/{id}/contribution/{code}`,
        GET_MAXIMUN_DATE_ALLOWED: `${SERVICE_CLOUD}/v1/voucher/availability/update?flowId={flowId}`,
        PAYMENT_CONTEXT:`${SERVICE_CLOUD}/v1/payment/payment-context/{flowId}`,
        SUMMARY: `${SERVICE_CLOUD}/v1/voucher/{flowId}/summary`,
        PAYMENT_COMPONENT_URI: PAYMENT_COMPONENT_URI,
        UPDATE_PAYMENT_CONTEXT: `${SERVICE_CLOUD}/v1/payment/payment-context/{flowId}`,
        NEW_PAYMENT_AVAILABILITY: `${SERVICE_URI}/pmt-ppm/rs/ppm/v7/config/new-payment-available/market/{market}/realm/GIFTCARD`
    },
    THEME: 'GIFT',
    PATTERNS: {
        NAME_SURNAME_PATTERN: /^(?!.*[0-9*¡!?¿<>\\ºª|/·@#$%&,;=()_+{}\[\]"^€£])/,
        CONTRIBUTION_SURNAME_PATTERN: '^[^0-9*¡!?¿<>ºª|/·@#$%&,;=()_+{}\[\]"^€£]*$',
        NAME_SURNAME_CLEANER: '[0-9*¡!?¿<>\\ºª|/·@#$%&,;=?¿())_+{}\\[\\]"\\^€$£]',
        EMAIL_PATTERN: '[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,6}',
        EMAIL_CLEANER: '\\s+',
        PHONE_PATTERN: /^\d{8,}$/,
        PHONE_CLEANER: '\\D+',
        CVV_PATTERN: /^\d+$/,
        CVV_CLEANER: '\\D+',
        CREDIT_CARD_NUMBER_PATTERN: /^\d+$/,
        CREDIT_CARD_NUMBER_CLEANER: '\\D+',
        CARD_NUMBER_PATTERN: /^\d+$/,
        CARD_NUMBER_CLEANER: '\\D+',
        DOCS_PATTERN: /^(?!.*[¡!?¿<>\\\\ºª|/\·@#$%&,;=?¿())_+{}\[\]"\^€$£])/,
        DOCS_CLEANER: '[¡!?¿<>\\\\ºª|/\\·@#$%&,;=?¿())_+{}\\[\\]"\\^€$£]',
        REDRESS_NUMBER_PATTERN: /^[a-zA-Z0-9\s]+$/,
        REDRESS_NUMBER_CLEANER: '[^a-zA-Z0-9\\s]',
        ERROR_RESIDENT_PATTERN: /residentDiscountInfo.residentCertificateNumber/,
        ERROR_CONGRESSMAN_PATTERN: /idInfo/,
        ERROR_FIRST_SURNAME: /firstSurname/,
        ERROR_FREQ_FLYER: /ffInfo.number/,
        AWS_WARNING_ERRORS: /AWS/,
        CONGRESSNAB_PATTERN: '[0-9]{1,12}',
        ADDITIONAL_FIELD_PATTERN: /^(?!.*[¡!?¿<>\\ºª|/·@#$%&,;=()_+{}\[\]"^€£])/,
        ADDITIONAL_FIELD_CLEANER: '[¡!?¿<>\\ºª|/·@#$%&,;=?¿())_+{}\\[\\]"\\^€$£]',
        STREET_PATTERN: /(?!.*[0-9{8,}*$¡!?¿<>\\ºª|/·@#%&,;=()_+{}\[\]"^€£])/,
        STREET_CLEANER: '[0-9{8,}*$¡!?¿<>\\ºª|/·@#$%&,;=()_+{}\\[\\]"\^€£]',
        CITY_PATTERN: /(?!.*[0-9*¡!?¿<>\\ºª|/·@#$%&,;=()_+{}\[\]"^€£])/,
        CITY_CLEANER: '[0-9*¡!?¿<>\\ºª|/·@#$%&,;=?¿())_+{}\\[\\]"\\^€$£]',
        RUC_DOCUMENT: /^([0-9]){11}$/,
        RUC_CLEANER: '\\D+',
        CDI_DOCUMENT: /^([0-9]){0,11}$/,
        ONBUSINESS_NUMBER_PATTERN: '\\d',
        AA_CARD_PATTERN: /[a-zA-Z0-9]/,
        AA_CARD_CLEANER: '[^a-zA-Z0-9]',
        DNI_DOCUMENT: /^([0-9]{8})[A-Za-z]$/m,
        PRICE_INTEGER: /^([0-9])*$/
    },
    MAX_FIELD_LENGTH: {
        MAX_LENGTH_REDRESSNUMBER: 15,
        MAX_LENGTH_NAME: 30,
        MAX_LENGTH_SURNAME: 30,
        MAX_LENGTH_FIRST_SURNAME: 39,
        MAX_LENGTH_LAST_SURNAME: 19,
        MAX_LENGTH_IBERIA_CARD: 8,
        MAX_LENGTH_OTHER_FREQUENTFLYER_CARD: 20,
        MAX_LENGTH_DNI: 9,
        MAX_LENGTH_MANDATORY_DOC: 20,
        MAX_LENGTH_ZIP_CODE: 10,
        MAX_LENGTH_PIN: 6,
        MAX_LENGTH_ADDITIONAL_FIELD: 30,
        MAX_LENGTH_MANDATORY_DOC_RUC: 11,
        MAX_LENGTH_EMAIL: 60
    },
    MIN_FIELD_LENGTH: {
        MIN_LENGTH_NAME: 2
    },
    PUT_GIFT_CARD: {
        MINE: 'mine',
        OTHER: 'other-person',
        OWN: 'OWN',
        GROUP: 'GROUP',
        INDIVIDUAL: 'INDIVIDUAL'
    },
    LANDING_URL: {
        ES: '/tarjeta-regalo/',
        EN: '/gift-card/',
        CA: '/targeta-regal/',
        DE: '/Geschenkkarte/',
        FR: '/carte-cadeau/',
        IT: '/carta-regalo/',
        NL: '/cadeaubon/',
        PT: '/cartao-presente/',
        RU: '/podarochanya-karta/',
        JA: 'ja/gift-card/',
        ZH: 'zh/gift-card/'
    },
    AVAILABLE_MARKETS: {
        ES: 'ES',
        EN: 'EN',
        CA: 'CA',
        DE: 'DE',
        FR: 'FR',
        IT: 'IT',
        NL: 'NL',
        PT: 'PT',
        RU: 'RU',
        JA: 'JA',
        ZH: 'ZH'
    },
    PAGES_ROUTES: {
        PAYMENTS: '/ibpurc',
        NEWPAYMENTS:'/ibpurco'
    },
    FLOWAPP: 'GIFTCARDS',
    GIFT_CARD_FLOWS: {
        CONTRIBUTION: 'contribution'
    },
    CONTRIBUTION_ERRORS: {
        APP_VCH_ERR_0005:'ib-contribution-service-expired-error-gift-cards-contribution.html',
        APP_VCH_ERR_0007:'ib-contribution-service-error-gift-cards-contribution.html',
        APP_VCH_ERR_0008:'ib-contribution-service-error-maximum-amount-exceeded-gift-cards-contribution.html'
    },
    PAYMENTS: {
        PAYMENTSTATUSOK: 'OK',
        PAYMENTSTATUSKO: 'KO'
    },
    GIFT_CARDS_BACK: 'GIFT_CARDS_BACK',
    SESSION_STORAGE: {
        IS_NEW_PAYMENT: 'isNewPayment',
        CONFIGURATION_INFO: 'giftCardsConfigurationInfo',
        PAYMENT_CONTEXT_RESPONSE: 'giftCardspaymentContextResponse',
        SUMMARY: 'giftCardsSummary'
    },
    CARD_THEMES_MODEL_SPECIAL_CAMPAIGN: {
        HALLOWEEN: {
            backGroundType: 9,
            id: 'divCard8',
            inputId: 'card-8',
            value: 'FATHER',
            figureClassType: 'heart',
            imgIcon: 'icon-pumpkin',
            text: 'GIFT_CARD_CONFIGURATION_HALLOWEEN',
            theme: 'FATHER',
            checked: false
        },
        SUMMER: {
            backGroundType: 'verano summerCampaignBackgroud',
            id: 'divCard8',
            inputId: 'card-8',
            value: 'FATHER',
            figureClassType: 'father summerCampaignFigureImage',
            imgIcon: 'icon-verano',
            text: 'GIFT_CARD_CONFIGURATION_SUMMER',
            theme: 'FATHER',
            checked: false
        },
        PRIDE: {
            backGroundType: '10',
            id: 'divCard8',
            inputId: 'card-8',
            value: 'FATHER',
            figureClassType: 'heart',
            imgIcon: 'icon-corazon-pride',
            text: 'GIFT_CARD_CONFIGURATION_WORLD_PRIDE',
            theme: 'FATHER',
            checked: false
        }

    },
    CARD_THEMES_MODEL_FIRST_ROW: [
        {
            backGroundType: 1,
            id: 'divCard1',
            inputId: 'card-1',
            value: 'GIFT',
            figureClassType: 'gift',
            imgIcon: 'icon-regalo',
            text: 'GIFT_CARD_CONFIGURATION_GIFT',
            theme: 'GIFT',
            checked: true
        },
        {
            backGroundType: 2,
            id: 'divCard2',
            inputId: 'card-2',
            value: 'HEART',
            figureClassType: 'heart',
            imgIcon: 'icon-corazon',
            text: 'GIFT_CARD_CONFIGURATION_HEART',
            theme: 'HEART',
            checked: false
        },
        {
            backGroundType: 3,
            id: 'divCard3',
            inputId: 'card-3',
            value: 'BABY',
            figureClassType: 'baby',
            imgIcon: 'icon-bebe',
            text: 'GIFT_CARD_CONFIGURATION_BABY',
            theme: 'BABY',
            checked: false
        },
        {
            backGroundType: 4,
            id: 'divCard4',
            inputId: 'card-4',
            value: 'GRADUATION',
            figureClassType: 'graduation',
            imgIcon: 'icon-graduacion',
            text: 'GIFT_CARD_CONFIGURATION_GRADUATION',
            theme: 'GRADUATION',
            checked: false
        }
    ],
    CARD_THEMES_MODEL_SECOND_ROW: [
        {
            backGroundType: 5,
            id: 'divCard5',
            inputId: 'card-5',
            value: 'BIRTHDAY',
            figureClassType: 'birthday',
            imgIcon: 'icon-cumpleanos',
            text: 'GIFT_CARD_CONFIGURATION_BIRTHDAY',
            theme: 'BIRTHDAY',
            checked: false
        },
        {
            backGroundType: 1,
            id: 'divCard6',
            inputId: 'card-6',
            value: 'CHRISTMAS',
            figureClassType: 'christmas',
            imgIcon: 'icon-navidad',
            text: 'GIFT_CARD_CONFIGURATION_CHRISTMAS',
            theme: 'CHRISTMAS',
            checked: false
        },
        {
            backGroundType: 6,
            id: 'divCard7',
            inputId: 'card-7',
            value: 'MOTHER',
            figureClassType: 'mother',
            imgIcon: 'icon-madre',
            text: 'GIFT_CARD_CONFIGURATION_MOTHER',
            theme: 'MOTHER',
            checked: false
        },
        {
            backGroundType: 7,
            id: 'divCard8',
            inputId: 'card-8',
            value: 'FATHER',
            figureClassType: 'father',
            imgIcon: 'icon-padre',
            text: 'GIFT_CARD_CONFIGURATION_FATHER',
            theme: 'FATHER',
            checked: false
        }
    ],
    CARD_SELECTED_MODELS: {
        GIFT: {
            logo: '../iberia-web-content/imagenes/gift-cards/logo-iberia-blanco.png',
            backGroundImage: '../iberia-web-content/imagenes/gift-cards/tarjeta-1.png',
            iconClass: 'ib-gift-card__icon--gift',
            icon: '../iberia-web-content/imagenes/gift-cards/icon-regalo.png',
            translates: {
                altLogo: 'GIFT_CARD_CONFIGURATION_ALT_CARD_PICTURE',
                altFigure: 'GIFT_CARD_CONFIGURATION_ALT_CARD_PICTURE',
                altTheme: 'GIFT_CARD_CONFIGURATION_GIFT',
                title: 'GIFT_CARD_CONFIGURATION_GIFT_CARD_TEXT',
                expiration: 'GIFT_CARD_CONFIGURATION_EXPIRATION',
                code: 'GIFT_CARD_CONFIGURATION_CODE'
            }
        },
        CHRISTMAS: {
            logo: '../iberia-web-content/imagenes/gift-cards/logo-iberia-blanco.png',
            backGroundImage: '../iberia-web-content/imagenes/gift-cards/tarjeta-1.png',
            iconClass: 'ib-gift-card__icon--christmas',
            icon: '../iberia-web-content/imagenes/gift-cards/icon-navidad.png',
            translates: {
                altLogo: 'GIFT_CARD_CONFIGURATION_ALT_CARD_PICTURE',
                altFigure: 'GIFT_CARD_CONFIGURATION_ALT_CARD_PICTURE',
                altTheme: 'GIFT_CARD_CONFIGURATION_CHRISTMAS',
                title: 'GIFT_CARD_CONFIGURATION_GIFT_CARD_TEXT',
                expiration: 'GIFT_CARD_CONFIGURATION_EXPIRATION',
                code: 'GIFT_CARD_CONFIGURATION_CODE'
            }
        },
        HEART: {
            logo: '../iberia-web-content/imagenes/gift-cards/logo-iberia-rojo.png',
            backGroundImage: '../iberia-web-content/imagenes/gift-cards/tarjeta-2.png',
            iconClass: 'ib-gift-card__icon--heart',
            icon: '../iberia-web-content/imagenes/gift-cards/icon-corazon.png',
            translates: {
                altLogo: 'GIFT_CARD_CONFIGURATION_ALT_CARD_PICTURE',
                altFigure: 'GIFT_CARD_CONFIGURATION_ALT_CARD_PICTURE',
                altTheme: 'GIFT_CARD_CONFIGURATION_HEART',
                title: 'GIFT_CARD_CONFIGURATION_GIFT_CARD_TEXT',
                expiration: 'GIFT_CARD_CONFIGURATION_EXPIRATION',
                code: 'GIFT_CARD_CONFIGURATION_CODE'
            }
        },
        BABY: {
            logo: '../iberia-web-content/imagenes/gift-cards/logo-iberia-blanco.png',
            backGroundImage: '../iberia-web-content/imagenes/gift-cards/tarjeta-3.png',
            iconClass: 'ib-gift-card__icon--baby',
            icon: '../iberia-web-content/imagenes/gift-cards/icon-bebe.png',
            translates: {
                altLogo: 'GIFT_CARD_CONFIGURATION_ALT_CARD_PICTURE',
                altFigure: 'GIFT_CARD_CONFIGURATION_ALT_CARD_PICTURE',
                altTheme: 'GIFT_CARD_CONFIGURATION_BABY',
                title: 'GIFT_CARD_CONFIGURATION_GIFT_CARD_TEXT',
                expiration: 'GIFT_CARD_CONFIGURATION_EXPIRATION',
                code: 'GIFT_CARD_CONFIGURATION_CODE'
            }
        },
        GRADUATION: {
            logo: '../iberia-web-content/imagenes/gift-cards/logo-iberia-blanco.png',
            backGroundImage: '../iberia-web-content/imagenes/gift-cards/tarjeta-4.png',
            iconClass: 'ib-gift-card__icon--graduation',
            icon: '../iberia-web-content/imagenes/gift-cards/icon-graduacion.png',
            translates: {
                altLogo: 'GIFT_CARD_CONFIGURATION_ALT_CARD_PICTURE',
                altFigure: 'GIFT_CARD_CONFIGURATION_ALT_CARD_PICTURE',
                altTheme: 'GIFT_CARD_CONFIGURATION_GRADUATION',
                title: 'GIFT_CARD_CONFIGURATION_GIFT_CARD_TEXT',
                expiration: 'GIFT_CARD_CONFIGURATION_EXPIRATION',
                code: 'GIFT_CARD_CONFIGURATION_CODE'
            }
        },
        BIRTHDAY: {
            logo: '../iberia-web-content/imagenes/gift-cards/logo-iberia-blanco.png',
            backGroundImage: '../iberia-web-content/imagenes/gift-cards/tarjeta-5.png',
            iconClass: 'ib-gift-card__icon--birthday',
            icon: '../iberia-web-content/imagenes/gift-cards/icon-cumpleanos.png',
            translates: {
                altLogo: 'GIFT_CARD_CONFIGURATION_ALT_CARD_PICTURE',
                altFigure: 'GIFT_CARD_CONFIGURATION_ALT_CARD_PICTURE',
                altTheme: 'GIFT_CARD_CONFIGURATION_BIRTHDAY',
                title: 'GIFT_CARD_CONFIGURATION_GIFT_CARD_TEXT',
                expiration: 'GIFT_CARD_CONFIGURATION_EXPIRATION',
                code: 'GIFT_CARD_CONFIGURATION_CODE'
            }
        },
        MOTHER: {
            logo: '../iberia-web-content/imagenes/gift-cards/logo-iberia-blanco.png',
            backGroundImage: '../iberia-web-content/imagenes/gift-cards/tarjeta-7.png',
            iconClass: 'ib-gift-card__icon--mother',
            icon: '../iberia-web-content/imagenes/gift-cards/icon-madre.png',
            translates: {
                altLogo: 'GIFT_CARD_CONFIGURATION_ALT_CARD_PICTURE',
                altFigure: 'GIFT_CARD_CONFIGURATION_ALT_CARD_PICTURE',
                altTheme: 'GIFT_CARD_CONFIGURATION_MOTHER',
                title: 'GIFT_CARD_CONFIGURATION_GIFT_CARD_TEXT',
                expiration: 'GIFT_CARD_CONFIGURATION_EXPIRATION',
                code: 'GIFT_CARD_CONFIGURATION_CODE'
            }
        },
        FATHER: {
            logo: '../iberia-web-content/imagenes/gift-cards/logo-iberia-blanco.png',
            backGroundImage: '../iberia-web-content/imagenes/gift-cards/tarjeta-8.png',
            iconClass: 'ib-gift-card__icon--father',
            icon: '../iberia-web-content/imagenes/gift-cards/icon-padre.png',
            translates: {
                altLogo: 'GIFT_CARD_CONFIGURATION_ALT_CARD_PICTURE',
                altFigure: 'GIFT_CARD_CONFIGURATION_ALT_CARD_PICTURE',
                altTheme: 'GIFT_CARD_CONFIGURATION_FATHER',
                title: 'GIFT_CARD_CONFIGURATION_GIFT_CARD_TEXT',
                expiration: 'GIFT_CARD_CONFIGURATION_EXPIRATION',
                code: 'GIFT_CARD_CONFIGURATION_CODE'
            }
        },
        HALLOWEEN: {
            logo: '../iberia-web-content/imagenes/gift-cards/logo-iberia-blanco.png',
            backGroundImage: '../iberia-web-content/imagenes/gift-cards/tarjeta-10.png',
            iconClass: 'ib-gift-card__icon--father',
            icon: '../iberia-web-content/imagenes/gift-cards/icon-pumpkin.png',
            translates: {
                altLogo: 'GIFT_CARD_CONFIGURATION_ALT_CARD_PICTURE',
                altFigure: 'GIFT_CARD_CONFIGURATION_ALT_CARD_PICTURE',
                altTheme: 'GIFT_CARD_CONFIGURATION_HALLOWEEN',
                title: 'GIFT_CARD_CONFIGURATION_GIFT_CARD_TEXT',
                expiration: 'GIFT_CARD_CONFIGURATION_EXPIRATION',
                code: 'GIFT_CARD_CONFIGURATION_CODE'
            }
        },
        SUMMER: {
            logo: '../iberia-web-content/imagenes/gift-cards/logo-iberia-blanco.png',
            backGroundImage: '../iberia-web-content/imagenes/gift-cards/tarjeta-verano.png',
            iconClass: 'ib-gift-card__icon--verano',
            icon: '../iberia-web-content/imagenes/gift-cards/icon-verano.png',
            translates: {
                altLogo: 'GIFT_CARD_CONFIGURATION_ALT_CARD_PICTURE',
                altFigure: 'GIFT_CARD_CONFIGURATION_ALT_CARD_PICTURE',
                altTheme: 'GIFT_CARD_CONFIGURATION_SUMMER',
                title: 'GIFT_CARD_CONFIGURATION_GIFT_CARD_TEXT',
                expiration: 'GIFT_CARD_CONFIGURATION_EXPIRATION',
                code: 'GIFT_CARD_CONFIGURATION_CODE'
            }
        },
        PRIDE: {
            logo: '../iberia-web-content/imagenes/gift-cards/logo-iberia-rojo.png',
            backGroundImage: '../iberia-web-content/imagenes/gift-cards/tarjeta-11.png',
            iconClass: 'ib-gift-card__icon--corazon-pride',
            icon: '../iberia-web-content/imagenes/gift-cards/icon-corazon-pride.png',
            translates: {
                altLogo: 'GIFT_CARD_CONFIGURATION_ALT_CARD_PICTURE',
                altFigure: 'GIFT_CARD_CONFIGURATION_ALT_CARD_PICTURE',
                altTheme: 'GIFT_CARD_CONFIGURATION_SUMMER',
                title: 'GIFT_CARD_CONFIGURATION_GIFT_CARD_TEXT',
                expiration: 'GIFT_CARD_CONFIGURATION_EXPIRATION',
                code: 'GIFT_CARD_CONFIGURATION_CODE'
            }
        }
    }
};
